import { BRImages } from '../assets/imgs';
import PATHS from '../routes/paths';

export const filters = [
  { value: 0, label: 'All' },
  { value: 1, label: 'Public Lecture' },
  { value: 2, label: 'Sunday School' },
  { value: 3, label: 'Bible Class' },
  { value: 4, label: 'Study days' },
  { value: 5, label: 'Memorial Meetings' }
];

export const mediaFilters = [
  { value: 'keywords', label: 'Keywords' },
  { value: 'locations', label: 'Locations' },
  { value: 'people', label: 'People' }
];

export const tags = [
  { value: 'work', title: 'Work' },
  { value: 'christ', title: 'Christ' },
  { value: 'church', title: 'Church' },
  { value: 'paul', title: 'Paul' },
  { value: 'high_priest', title: 'High Priest' },
  { value: 'hebrew_tongue', title: 'Hebrew Tongue' },
  { value: 'devout', title: 'Devout' },
  { value: 'subtle_hint', title: 'Subtle hint' },
  { value: 'devout_man', title: 'Devout man' }
];

export const videoData = [
  {
    id: 1,
    title: 'Class 2: Before the Brethren',
    speaker: 'Jesse Adair',
    date: 'Feb 25, 2024',
    url: 'https://vimeo.com/753580183',
    theme: 'Faith and Trials',
    timer: '45:23',
    documents: [
      { title: 'Document 1', url: 'https://pdfobject.com/pdf/sample.pdf' },
      {
        title: 'Document 2',
        url: 'https://view.officeapps.live.com/op/view.aspx?src=https%3A%2F%2Fcalibre-ebook.com%2Fdownloads%2Fdemos%2Fdemo.docx&wdOrigin=BROWSELINK'
      }
    ]
  },
  {
    id: 2,
    title: 'Class 3: The Trials of Paul',
    speaker: 'John Doe',
    date: 'Mar 15, 2024',
    url: 'https://example.com/video2.mp4',
    theme: 'Perseverance',
    timer: '45:23',
    documents: [{ title: 'Document 3', url: 'https://example.com/doc3.pdf' }]
  },
  {
    id: 3,
    title: 'Class 4: Faith and Trials',
    speaker: 'Jane Doe',
    date: 'Apr 10, 2024',
    url: 'https://example.com/video3.mp4',
    theme: 'Courage',
    timer: '45:23',
    documents: [{ title: 'Document 4', url: 'https://example.com/doc4.pdf' }]
  }
];

export const audioData = [
  {
    title: "The story of God's glory",
    speaker: 'Josh Hodge',
    url: 'https://www2.cs.uic.edu/~i101/SoundFiles/ImperialMarch60.wav',
    date: 'Feb 25 2024'
  },
  {
    title: 'Another audio title',
    speaker: 'John Doe',
    url: 'https://www2.cs.uic.edu/~i101/SoundFiles/PinkPanther60.wav',
    date: 'Feb 25 2024'
  }
];

export const carouselData = [
  {
    imgSrc: BRImages.HomeImages.CarouselBg1,
    title: 'Why Does God Give Man Freewill?',
    subtitle: {
      eventType: 'Public Lecture',
      date: 'September 08, 2024',
      time: '6:00 PM'
    }
  },
  {
    imgSrc: BRImages.HomeImages.CarouselBg1,
    title: 'The Purpose of Life',
    subtitle: {
      eventType: 'Public Lecture',
      date: 'September 15, 2024',
      time: '6:00 PM'
    }
  },
  {
    imgSrc: BRImages.HomeImages.CarouselBg1,
    title: 'Understanding the Bible',
    subtitle: {
      eventType: 'Bible Study',
      date: 'September 22, 2024',
      time: '5:00 PM'
    }
  },
  {
    imgSrc: BRImages.HomeImages.CarouselBg1,
    title: 'Faith in Uncertainty',
    subtitle: {
      eventType: 'Public Lecture',
      date: 'September 22, 2024',
      time: '5:00 PM'
    }
  }
];

export const carouselBelieveImages = [
  { imageUrl: BRImages.WhatWeBelieveImages.CarouselImg1 },
  { imageUrl: BRImages.WhatWeBelieveImages.CarouselImg2 },
  { imageUrl: BRImages.WhatWeBelieveImages.CarouselImg3 },
];

export const carouselBibleSeminarImages = [
  { imageUrl: BRImages.BibleSeminarImages.SeminarCarouselImg1 },
  { imageUrl: BRImages.BibleSeminarImages.SeminarCarouselImg2 },
  { imageUrl: BRImages.BibleSeminarImages.SeminarCarouselImg3 },
];

export const lectureData = [
  {
    month: 'Sep',
    date: '15',
    title: 'Social Media: How to Protect Our Selves',
    time: '6.00 PM - 8.00 PM'
  },
  {
    month: 'Sep',
    date: '22',
    title: 'Why Was Jesus Baptized',
    time: '6.00 PM - 8.00 PM'
  },
  {
    month: 'Sep',
    date: '29',
    title: 'Holi Spirit Gifts Today: Genuine or Fraud?',
    time: '6.00 PM - 8.00 PM'
  }
];
export const growYourFaithData = {
  slides: [
    {
      title: 'What We Believe',
      description:
        "Christadelphians base their beliefs solely on what's found in the Bible. Learn more about our beliefs as Christadelphians and how God’s word serves as the foundation of our faith.",
      path: PATHS.WHAT_WE_BELIEVE
    },
    {
      title: 'Public Events',
      description:
        'In addition to our weekly public lectures on interesting Bible topics, we host a variety of special events and activities. Join us to explore the incredible insights and teachings found in the Bible!',
      path: PATHS.PUBLIC_EVENTS
    },
    {
      title: 'Bible Seminars',
      description:
        'Join our seminars to learn to read the Bible effectively and find answers to your questions in a warm and welcoming environment.',
      path: PATHS.BIBLE_SEMINARS
    },
    {
      title: 'WebCast',
      description:
        'We regularly broadcast our Bible talks and lectures online. Click below to watch a live stream of Bible-based talks through the webcast.',
      path: PATHS.WEB_CAST_SIGN_IN
    }
  ],
  prevArrow: BRImages.CommonImages.ArrowBlackRight,
  nextArrow: BRImages.CommonImages.ArrowBlackRight
};

export const webcastUserData = [
  {
    icon: BRImages.WebCastImages.GuestIcon,
    title: 'Join as Guest',
    message: 'Join as Guest',
    userType: 'Guest'
  },
  {
    icon: BRImages.WebCastImages.ChristadelphianIcon,
    title: 'Login as other Christadelphian Ecclesia Member',
    userType: 'Affiliate_Ecclesia_Member'
  },
  {
    icon: BRImages.WebCastImages.MemberIcon,
    title: 'Login as Book Road Ecclesia Member',
    message: 'Login as Book Road Ecclesia Member',
    userType: 'Book_Road_Member'
  }
];

export const Tabledata = [
  {
    key: '1',
    name: 'Alfa 001',
    date: '24/03/2024',
    username: 'AprilUser',
    email: 'probinson@bookroad.com',
    status: 'Pending',
    role: 'None',
    actions: 'notSelected'
  },
  {
    key: '2',
    name: 'Beta 002',
    date: '25/03/2024',
    username: 'MayUser',
    email: 'mjohnson@bookroad.com',
    status: 'Accepted',
    role: 'Administrators',
    actions: 'selected'
  },
  {
    key: '3',
    name: 'Gamma 003',
    date: '26/03/2024',
    username: 'JuneUser',
    email: 'kjames@bookroad.com',
    status: 'Rejected',
    role: 'Administrators',
    actions: 'rejected'
  }
];

export const documentData = [
  {
    id: 1,
    title: 'Document 1',
    author: 'Author 1',
    date: '2023-10-01',
    url: 'https://icseindia.org/document/sample.pdf'
  },
  {
    id: 2,
    title: 'Document 2',
    author: 'Author 2',
    date: '2023-10-05',
    url: 'https://pdfobject.com/pdf/sample.pdf'
  }
];

export const resourceLinkCard = [
  {
    title: 'Link 1',
    textToDisplay: 'Link title 1',
    url: 'http://www.company.com:81/a/b/c.html?u..'
  },
  {
    title: 'Link 2',
    textToDisplay: 'Link title 1',
    url: 'http://www.company.com:81/a/b/c.html?u..'
  },
  {
    title: 'Link 3',
    textToDisplay: 'Recorded Bible Talks',
    url: 'http://www.company.com:81/a/b/c.html?u..'
  }
];

export const publicEventsData = [
  {
    imgUrl: BRImages.PublicEventsImages.PublicEventsBg2,
    title: 'Public Event Name',
    uploadedBy: 'Admin Name',
    uploadedOn: '2024/05/05'
  },
  {
    imgUrl: BRImages.PublicEventsImages.PublicEventsBg1,
    title: 'Public Event Name',
    uploadedBy: 'Admin Name',
    uploadedOn: '2024/05/05'
  }
];

export const bibleSeminarsAdminData = [
  {
    title: 'Bible Seminar Title..',
    location: 'Location',
    createdBy: 'Admin Name',
    date: '2024/05/05',
    time: '09:50:58'
  },
  {
    title: 'Bible Seminar Title..',
    location: 'Location',
    createdBy: 'Admin Name',
    date: '2024/05/05',
    time: '09:50:58'
  },
  {
    title: 'Bible Seminar Title..',
    location: 'Location',
    createdBy: 'Admin Name',
    date: '2024/05/05',
    time: '09:50:58'
  },
  {
    title: 'Bible Seminar Title..',
    location: 'Location',
    createdBy: 'Admin Name',
    date: '2024/05/05',
    time: '09:50:58'
  }
];

export const privacyPolicy = [
  {
    title: '',
    descp: `bookroadchristadelphians is committed to protecting your privacy and
                    developing technology that gives you the most powerful and safe online experience.
                    This Statement of Privacy applies to the bookroadchristadelphians site and governs data collection and usage.
                    By using the bookroadchristadelphians site, you consent to the data practices described in this statement.`
  },
  {
    title: 'Collection of your Personal Information',
    descp: [
      `bookroadchristadelphians collects personally identifiable information, such as your email address, name, home or work address or telephone number. bookroadchristadelphians also collects anonymous demographic information, which is not unique to you, such as your ZIP code, age, gender, preferences, interests and favorites.`,
      `There is also information about your computer hardware and software that is automatically collected by bookroadchristadelphians. This information can include: your IP address, browser type, domain names, access times and referring website addresses. This information is used by bookroadchristadelphians for the operation of the service, to maintain quality of the service, and to provide general statistics regarding use of the bookroadchristadelphians site.`,
      `Please keep in mind that if you directly disclose personally identifiable information or personally sensitive data through bookroadchristadelphians public message boards, this information may be collected and used by others. Note: bookroadchristadelphians does not read any of your private online communications.`,
      `bookroadchristadelphians encourages you to review the privacy statements of Web sites you choose to link to from bookroadchristadelphians so that you can understand how those Web sites collect, use and share your information. bookroadchristadelphians is not responsible for the privacy statements or other content on Web sites outside of the bookroadchristadelphians and bookroadchristadelphians family of Web sites.`
    ]
  },
  {
    title: 'Use of your Personal Information',
    descp: [
      `bookroadchristadelphians collects and uses your personal information to operate the bookroadchristadelphians Web site and deliver the services you have requested. bookroadchristadelphians also uses your personally identifiable information to inform you of other products or services available from bookroadchristadelphians and its affiliates. bookroadchristadelphians may also contact you via surveys to conduct research about your opinion of current services or of potential new services that may be offered. `,
      `bookroadchristadelphians does not sell, rent or lease its customer lists to third parties. bookroadchristadelphians may, from time to time, contact you on behalf of external business partners about a particular offering that may be of interest to you. In those cases, your unique personally identifiable information (e-mail, name, address, telephone number) is not transferred to the third party. In addition, bookroadchristadelphians may share data with trusted partners to help us perform statistical analysis, send you email or postal mail, provide customer support, or arrange for deliveries. All such third parties are prohibited from using your personal information except to provide these services to bookroadchristadelphians, and they are required to maintain the confidentiality of your information.`,
      `bookroadchristadelphians does not use or disclose sensitive personal information, such as race, religion, or political affiliations, without your explicit consent.`,
      `bookroadchristadelphians keeps track of the Web sites and pages our customers visit within bookroadchristadelphians, in order to determine what bookroadchristadelphians services are the most popular. This data is used to deliver customized content and advertising within bookroadchristadelphians to customers whose behavior indicates that they are interested in a particular subject area.`,
      `bookroadchristadelphians Web sites will disclose your personal information, without notice, only if required to do so by law or in the good faith belief that such action is necessary to: (a) conform to the edicts of the law or comply with legal process served on bookroadchristadelphians or the site; (b) protect and defend the rights or property of bookroadchristadelphians; and, (c) act under exigent circumstances to protect the personal safety of users of bookroadchristadelphians, or the public.`,
    ]
  },
  {
    title: 'Use of Cookies',
    descp: [
      `The bookroadchristadelphians Web site use "cookies" to help you personalize your online experience. A cookie is a text file that is placed on your hard disk by a Web page server. Cookies cannot be used to run programs or deliver viruses to your computer. Cookies are uniquely assigned to you, and can only be read by a web server in the domain that issued the cookie to you.`,
      `One of the primary purposes of cookies is to provide a convenience feature to save you time. The purpose of a cookie is to tell the Web server that you have returned to a specific page. For example, if you personalize bookroadchristadelphians pages, or register with bookroadchristadelphians site or services, a cookie helps bookroadchristadelphians to recall your specific information on subsequent visits. This simplifies the process of recording your personal information, such as billing addresses, shipping addresses, and so on. When you return to the same bookroadchristadelphians Web site, the information you previously provided can be retrieved, so you can easily use the bookroadchristadelphians features that you customized.`,
      `You have the ability to accept or decline cookies. Most Web browsers automatically accept cookies, but you can usually modify your browser setting to decline cookies if you prefer. If you choose to decline cookies, you may not be able to fully experience the interactive features of the bookroadchristadelphians services or Web sites you visit.`,
    ]
  },
  {
    title: 'Security of your Personal Information',
    descp: [
      `bookroadchristadelphians secures your personal information from unauthorized access, use or disclosure. bookroadchristadelphians secures the personally identifiable information you provide on computer servers in a controlled, secure environment, protected from unauthorized access, use or disclosure. When personal information (such as a credit card number) is transmitted to other Web sites, it is protected through the use of encryption, such as the Secure Socket Layer (SSL) protocol.`,
    ]
  },
  {
    title: 'Changes to this Statement',
    descp: [
      `bookroadchristadelphians will occasionally update this Statement of Privacy to reflect company and customer feedback. bookroadchristadelphians encourages you to periodically review this Statement to be informed of how bookroadchristadelphians is protecting your information.`,
    ]
  },
  {
    title: 'Contact Information',
    descp: [
      <>
        bookroadchristadelphians welcomes your comments regarding this Statement of Privacy. If you believe that bookroadchristadelphians has not adhered to this Statement, please contact bookroadchristadelphians at <a href="mailto:bookroadchristadelphianfinance@gmail.com" className="text-blue-link cursor-pointer text-deco-none">bookroadchristadelphianfinance@gmail.com</a>. We will use commercially reasonable efforts to promptly determine and remedy the problem.,
      </>
    ]
  }
];

export const termsOfUse = [
  {
    title: 'AGREEMENT BETWEEN USER AND Book Road Christadelphians',
    descp: [
      `The Book Road Christadelphians Web Site is comprised of various Web pages operated by Book Road Christadelphians.`,
      `The Book Road Christadelphians Web Site is offered to you conditioned on your acceptance without modification of the terms, conditions, and notices contained herein. Your use of the Book Road Christadelphians Web Site constitutes your agreement to all such terms, conditions, and notices.`,
    ]
  },
  {
    title: 'MODIFICATION OF THESE TERMS OF USE',
    descp: [
      `Book Road Christadelphians reserves the right to change the terms, conditions, and notices under which the Book Road Christadelphians Web Site is offered, including but not limited to the charges associated with the use of the Book Road Christadelphians Web Site.`,
    ]
  },
  {
    title: 'LINKS TO THIRD PARTY SITES',
    descp: [
      `The Book Road Christadelphians Web Site may contain links to other Web Sites ("Linked Sites"). The Linked Sites are not under the control of Book Road Christadelphians and Book Road Christadelphians is not responsible for the contents of any Linked Site, including without limitation any link contained in a Linked Site, or any changes or updates to a Linked Site. Book Road Christadelphians is not responsible for webcasting or any other form of transmission received from any Linked Site. Book Road Christadelphians is providing these links to you only as a convenience, and the inclusion of any link does not imply endorsement by Book Road Christadelphians of the site or any association with its operators.`,
    ]
  },
  {
    title: 'NO UNLAWFUL OR PROHIBITED USE',
    descp: [
      `As a condition of your use of the Book Road Christadelphians Web Site, you warrant to Book Road Christadelphians that you will not use the Book Road Christadelphians Web Site for any purpose that is unlawful or prohibited by these terms, conditions, and notices. You may not use the Book Road Christadelphians Web Site in any manner which could damage, disable, overburden, or impair the Book Road Christadelphians Web Site or interfere with any other party's use and enjoyment of the Book Road Christadelphians Web Site. You may not obtain or attempt to obtain any materials or information through any means not intentionally made available or provided for through the Book Road Christadelphians Web Sites.`,
    ]
  },
  {
    title: 'USE OF COMMUNICATION SERVICES',
    descp: [
      `The Book Road Christadelphians Web Site may contain bulletin board services, chat areas, news groups, forums, communities, personal web pages, calendars, and/or other message or communication facilities designed to enable you to communicate with the public at large or with a group (collectively, "Communication Services"), you agree to use the Communication Services only to post, send and receive messages and material that are proper and related to the particular Communication Service. By way of example, and not as a limitation, you agree that when using a Communication Service, you will not:`,
      <>
        <ul className='line-height-24'>
          <li className='manrope-16-regular line-height-28 text-primary-blue'>
            Defame, abuse, harass, stalk, threaten or otherwise violate the legal rights
            (such as rights of privacy and publicity) of others.
          </li>
          <li className='manrope-16-regular line-height-28 text-primary-blue'>
            Publish, post, upload, distribute or disseminate any inappropriate, profane, defamatory, infringing, obscene,
            indecent or unlawful topic, name, material or information.
          </li>
          <li className='manrope-16-regular line-height-28 text-primary-blue'>
            Upload files that contain software or other material protected by intellectual property laws
            (or by rights of privacy of publicity) unless you own or control the rights thereto or have
            received all necessary consents.
          </li>
          <li className='manrope-16-regular line-height-28 text-primary-blue'>
            Upload files that contain viruses, corrupted files, or any other similar software or programs
            that may damage the operation of another's computer.
          </li>
          <li className='manrope-16-regular line-height-28 text-primary-blue'>
            Advertise or offer to sell or buy any goods or services for any business purpose,
            unless such Communication Service specifically allows such messages.
          </li>
          <li className='manrope-16-regular line-height-28 text-primary-blue'>
            Conduct or forward surveys, contests, pyramid schemes or chain letters.
          </li>
          <li className='manrope-16-regular line-height-28 text-primary-blue'>
            Download any file posted by another user of a Communication Service that you know,
            or reasonably should know, cannot be legally distributed in such manner.
          </li>
          <li className='manrope-16-regular line-height-28 text-primary-blue'>
            Falsify or delete any author attributions, legal or other proper notices or proprietary designations
            or labels of the origin or source of software or other material contained in a file that is uploaded.
          </li>
          <li className='manrope-16-regular line-height-28 text-primary-blue'>
            Restrict or inhibit any other user from using and enjoying the Communication Services.
          </li>
          <li className='manrope-16-regular line-height-28 text-primary-blue'>
            Violate any code of conduct or other guidelines which may be applicable for any particular
            Communication Service.
          </li>
          <li className='manrope-16-regular line-height-28 text-primary-blue'>
            Harvest or otherwise collect information about others, including e-mail addresses,
            without their consent.
          </li>
          <li className='manrope-16-regular line-height-28 text-primary-blue'>
            Violate any applicable laws or regulations.
          </li>
        </ul>
      </>,
      `Book Road Christadelphians has no obligation to monitor the Communication Services. However, Book Road Christadelphians reserves the right to review materials posted to a Communication Service and to remove any materials in its sole discretion. Book Road Christadelphians reserves the right to terminate your access to any or all of the Communication Services at any time without notice for any reason whatsoever.`,
      `Book Road Christadelphians reserves the right at all times to disclose any information as necessary to satisfy any applicable law, regulation, legal process or governmental request, or to edit, refuse to post or to remove any information or materials, in whole or in part, in Book Road Christadelphians's sole discretion.`,
      `Always use caution when giving out any personally identifying information about yourself or your children in any Communication Service. Book Road Christadelphians does not control or endorse the content, messages or information found in any Communication Service and, therefore, Book Road Christadelphians specifically disclaims any liability with regard to the Communication Services and any actions resulting from your participation in any Communication Service. Managers and hosts are not authorized Book Road Christadelphians spokespersons, and their views do not necessarily reflect those of Book Road Christadelphians.`,
      `Materials uploaded to a Communication Service may be subject to posted limitations on usage, reproduction and/or dissemination. You are responsible for adhering to such limitations if you download the materials.`
    ]
  },
  {
    title: 'MATERIALS PROVIDED TO Book Road Christadelphians OR POSTED AT ANY Book Road Christadelphians WEB SITE',
    descp: [
      `Book Road Christadelphians does not claim ownership of the materials you provide to Book Road Christadelphians (including feedback and suggestions) or post, upload, input or submit to any Book Road Christadelphians Web Site or its associated services (collectively "Submissions"). However, by posting, uploading, inputting, providing or submitting your Submission you are granting Book Road Christadelphians, its affiliated companies and necessary sublicensees permission to use your Submission in connection with the operation of their Internet businesses including, without limitation, the rights to: copy, distribute, transmit, publicly display, publicly perform, reproduce, edit, translate and reformat your Submission; and to publish your name in connection with your Submission.`,
      `No compensation will be paid with respect to the use of your Submission, as provided herein. Book Road Christadelphians is under no obligation to post or use any Submission you may provide and may remove any Submission at any time in Book Road Christadelphians's sole discretion.`,
      `By posting, uploading, inputting, providing or submitting your Submission you warrant and represent that you own or otherwise control all of the rights to your Submission as described in this section including, without limitation, all the rights necessary for you to provide, post, upload, input or submit the Submissions.`
    ]
  },
  {
    title: 'LIABILITY DISCLAIMER',
    descp: [
      `THE INFORMATION, SOFTWARE, PRODUCTS, AND SERVICES INCLUDED IN OR AVAILABLE THROUGH THE Book Road Christadelphians WEB SITE MAY INCLUDE INACCURACIES OR TYPOGRAPHICAL ERRORS. CHANGES ARE PERIODICALLY ADDED TO THE INFORMATION HEREIN. Book Road Christadelphians AND/OR ITS SUPPLIERS MAY MAKE IMPROVEMENTS AND/OR CHANGES IN THE Book Road Christadelphians WEB SITE AT ANY TIME. ADVICE RECEIVED VIA THE Book Road Christadelphians WEB SITE SHOULD NOT BE RELIED UPON FOR PERSONAL, MEDICAL, LEGAL OR FINANCIAL DECISIONS AND YOU SHOULD CONSULT AN APPROPRIATE PROFESSIONAL FOR SPECIFIC ADVICE TAILORED TO YOUR SITUATION.`,
      `Book Road Christadelphians AND/OR ITS SUPPLIERS MAKE NO REPRESENTATIONS ABOUT THE SUITABILITY, RELIABILITY, AVAILABILITY, TIMELINESS, AND ACCURACY OF THE INFORMATION, SOFTWARE, PRODUCTS, SERVICES AND RELATED GRAPHICS CONTAINED ON THE Book Road Christadelphians WEB SITE FOR ANY PURPOSE. TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, ALL SUCH INFORMATION, SOFTWARE, PRODUCTS, SERVICES AND RELATED GRAPHICS ARE PROVIDED "AS IS" WITHOUT WARRANTY OR CONDITION OF ANY KIND. Book Road Christadelphians AND/OR ITS SUPPLIERS HEREBY DISCLAIM ALL WARRANTIES AND CONDITIONS WITH REGARD TO THIS INFORMATION, SOFTWARE, PRODUCTS, SERVICES AND RELATED GRAPHICS, INCLUDING ALL IMPLIED WARRANTIES OR CONDITIONS OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE AND NON-INFRINGEMENT.`,
      `TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL Book Road Christadelphians AND/OR ITS SUPPLIERS BE LIABLE FOR ANY DIRECT, INDIRECT, PUNITIVE, INCIDENTAL, SPECIAL, CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER INCLUDING, WITHOUT LIMITATION, DAMAGES FOR LOSS OF USE, DATA OR PROFITS, ARISING OUT OF OR IN ANY WAY CONNECTED WITH THE USE OR PERFORMANCE OF THE Book Road Christadelphians WEB SITE, WITH THE DELAY OR INABILITY TO USE THE Book Road Christadelphians WEB SITE OR RELATED SERVICES, THE PROVISION OF OR FAILURE TO PROVIDE SERVICES, OR FOR ANY INFORMATION, SOFTWARE, PRODUCTS, SERVICES AND RELATED GRAPHICS OBTAINED THROUGH THE Book Road Christadelphians WEB SITE, OR OTHERWISE ARISING OUT OF THE USE OF THE Book Road Christadelphians WEB SITE, WHETHER BASED ON CONTRACT, TORT, NEGLIGENCE, STRICT LIABILITY OR OTHERWISE, EVEN IF Book Road Christadelphians OR ANY OF ITS SUPPLIERS HAS BEEN ADVISED OF THE POSSIBILITY OF DAMAGES. BECAUSE SOME STATES/JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF LIABILITY FOR CONSEQUENTIAL OR INCIDENTAL DAMAGES, THE ABOVE LIMITATION MAY NOT APPLY TO YOU. IF YOU ARE DISSATISFIED WITH ANY PORTION OF THE Book Road Christadelphians WEB SITE, OR WITH ANY OF THESE TERMS OF USE, YOUR SOLE AND EXCLUSIVE REMEDY IS TO DISCONTINUE USING THE Book Road Christadelphians WEB SITE.`,
      `SERVICE CONTACT : bookrdecclesia@gmail.com`
    ]
  },
  {
    title: 'TERMINATION/ACCESS RESTRICTION',
    descp: [
      `Book Road Christadelphians reserves the right, in its sole discretion, to terminate your access to the Book Road Christadelphians Web Site and the related services or any portion thereof at any time, without notice. GENERAL To the maximum extent permitted by law, this agreement is governed by the laws of the State of Washington, U.S.A. and you hereby consent to the exclusive jurisdiction and venue of courts in San Mateo County, California, U.S.A. in all disputes arising out of or relating to the use of the Book Road Christadelphians Web Site. Use of the Book Road Christadelphians Web Site is unauthorized in any jurisdiction that does not give effect to all provisions of these terms and conditions, including without limitation this paragraph. You agree that no joint venture, partnership, employment, or agency relationship exists between you and Book Road Christadelphians as a result of this agreement or use of the Book Road Christadelphians Web Site. Book Road Christadelphians's performance of this agreement is subject to existing laws and legal process, and nothing contained in this agreement is in derogation of Book Road Christadelphians's right to comply with governmental, court and law enforcement requests or requirements relating to your use of the Book Road Christadelphians Web Site or information provided to or gathered by Book Road Christadelphians with respect to such use. If any part of this agreement is determined to be invalid or unenforceable pursuant to applicable law including, but not limited to, the warranty disclaimers and liability limitations set forth above, then the invalid or unenforceable provision will be deemed superseded by a valid, enforceable provision that most closely matches the intent of the original provision and the remainder of the agreement shall continue in effect. Unless otherwise specified herein, this agreement constitutes the entire agreement between the user and Book Road Christadelphians with respect to the Book Road Christadelphians Web Site and it supersedes all prior or contemporaneous communications and proposals, whether electronic, oral or written, between the user andd Book Road Christadelphians with respect to the Book Road Christadelphians Web Site. 
      A printed version of this agreement and of any notice given in electronic form shall be admissible in judicial or administrative proceedings based upon or relating to this agreement to the same extent and subject to the same conditions as other business documents and records originally generated and maintained in printed form. It is the express wish to the parties that this agreement and all related documents be drawn up in English.`,
    ]
  },
  {
    title: 'COPYRIGHT AND TRADEMARK NOTICES:',
    descp: [
      `All contents of the Book Road Christadelphians Web Site are: [Portal:FooterText] and/or its suppliers. All rights reserved.`,
    ]
  },
  {
    title: 'TRADEMARKS',
    descp: [
      `The names of actual companies and products mentioned herein may be the trademarks of their respective owners.`,
      `The example companies, organizations, products, people and events depicted herein are fictitious. No association with any real company, organization, product, person, or event is intended or should be inferred.`,
      `Any rights not expressly granted herein are reserved.`
    ]
  },
]

export const introductionGreeting =
  'Good morning brothers and sisters, friends, young people all of you connecting in from near and far: We welcome around the table of the Lord this morning: ';

export const fillLines1 =
  '____________________________________________________________________________________';

export const fillLines2 =
  '____________________________________________________________________________________';

export const fillLines3 =
  '____________________________________________________________________________________';

export const introAddressMmbers =
  'We are mindful of elderly brothers and sisters dealing with challenges of age and health: Bro. Bob. Dunford, Sis. Sandra Mulholland, Bro John Leadbetter, Sis Sara Harrison ';

export const note = 'NOTE:';

export const introLine4 =
  'We would like to note this morning the many that join us through the webcast, brothers and sisters from various locations including:';

export const lastIntro =
  'Our ecclesia is organized and conducts our fellowship on the basis of the doctrines and precepts of the scriptures, as conveniently summarized in the Birmingham Amended Statement of Faith, and as historically upheld by the worldwide Central Fellowship of Christadelphians. All who are members in good standing of Central Christadelphian ecclesias that fellowship only on this basis are welcome to partake of the emblems. The following announcements are subject to the will of our Heavenly Father:';
